import React, { useEffect, useState } from 'react';
import { Card, List, Tag, Button, Empty, message, Space, Typography, Tooltip } from 'antd';
import { StarOutlined, CalendarOutlined } from '@ant-design/icons';
import api from '../../../services/api';
import RateGameModal from './RateGameModal';

const { Text } = Typography;

const GamesTab = () => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rateModal, setRateModal] = useState({ open: false, game: null });

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/community/player/games');
      setGames(r.data?.games || []);
    } catch (err) {
      message.error('Erro ao carregar jogos');
    }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const statusTag = (g) => {
    if (g.went) return <Tag color="green">Confirmado</Tag>;
    if (g.waitlist) return <Tag color="orange">Lista de espera</Tag>;
    if (g.response_at) return <Tag color="red">Não vou</Tag>;
    return <Tag>Sem resposta</Tag>;
  };

  const actionFor = (g) => {
    if (g.can_rate) return (
      <Button icon={<StarOutlined />} type="primary" onClick={() => setRateModal({ open: true, game: g })}>
        {g.already_rated ? 'Editar avaliação' : 'Avaliar'}
      </Button>
    );
    if (g.went && g.rating_window_expired) return (
      <Tooltip title="A janela de 24h para avaliar esse jogo já fechou.">
        <Tag>Prazo encerrado</Tag>
      </Tooltip>
    );
    if (g.already_rated) return <Tag color="blue">Você já avaliou</Tag>;
    return null;
  };

  return (
    <>
      <Card loading={loading} title={<><CalendarOutlined /> Meus jogos</>}>
        {games.length === 0 ? (
          <Empty description="Você ainda não foi convocado pra nenhum jogo." />
        ) : (
          <List
            dataSource={games}
            renderItem={(g) => {
              const action = actionFor(g);
              return (
                <List.Item actions={action ? [action] : undefined}>
                  <List.Item.Meta
                    title={<Space wrap>{g.date_of_game} {statusTag(g)}</Space>}
                    description={<Text type="secondary">{g.team_name}</Text>}
                  />
                </List.Item>
              );
            }}
          />
        )}
      </Card>

      <RateGameModal
        open={rateModal.open}
        game={rateModal.game}
        onClose={() => setRateModal({ open: false, game: null })}
        onSaved={load}
      />
    </>
  );
};

export default GamesTab;
